import { Component, OnInit, Input, Output } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';

@Component({
    selector: 'table-horizontal',
    templateUrl: './table-horizontal.component.html',
    styleUrls : ['./table.component.scss']
})

export class TablehorizontalComponent implements OnInit {
    @Input() public apiUrl: String = '/assets/dummy-data/incident-detail-dummy-data.json';

    allItems: any = {};

    tableConfig: any = {
        caption : 'table name',
        cellWidth : {
            title :  '20',
            desc : '80'
        }
    };

    constructor(private http: Http) { }

    ngOnInit() {
        // get dummy data
        this.http.get(location.origin + this.apiUrl)
            .map((response: Response) => response.json())
            .subscribe(data => {
                // set items to json response
                this.allItems = data;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/table/table-horizontal.component.ts